import { render, staticRenderFns } from "./BadgeCheck.vue?vue&type=template&id=d475f448&"
import script from "./BadgeCheck.vue?vue&type=script&lang=js&"
export * from "./BadgeCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports